import React, { useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { coins } from "../../constants/constants";
import GetRates from "../../components/utils/GetRates";
import { formatAmount } from "../../utils/formatTime";
import useUserAsset from "../../hooks/useUserAssets";
import GetTickers from "../../components/utils/GetTickers";

const CryptoRate = ({ setOpenCryptoRate }: any) => {
  const [amount, setAmount] = useState<string>("");
  const [selectedCoinObj, setSelectedCoinObj] = useState<any>(null);
  const { loading } = useUserAsset();

  const [coin, setCoin] = useState<string>("");
  const isNumber = (str: any) => {
    if (str.trim() === "") {
      return false;
    }

    return !isNaN(str);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (isNumber(value)) {
      setAmount(value);
    } else {
      setAmount("");
    }
  };
  const rate = GetRates("USDT");
  const { data: coinRates, isLoading } = GetTickers();
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-4 items-center">
          <button
            onClick={() => {
              setOpenCryptoRate(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            See Crypto Rates
          </h4>
        </div>
        <div className="w-full mt-10">
          <h4 className="text-[13px] text-gray-700 dark:text-gray-300">
            Select Coin
          </h4>

          <div className="h-[48px]  rounded-xl border border-gray-300 dark:border-gray-600 px-2 mt-2 flex gap-1 justify-start items-center">
            {selectedCoinObj && (
              <div className="flex justify-center items-center  w-[20px] h-[20px] rounded-full">
                <img
                  src={selectedCoinObj?.logo ? selectedCoinObj?.logo : ""}
                  className="w-full h-full bg-cover"
                  alt=""
                />
              </div>
            )}

            <select
              value={coin}
              onChange={(e) => {
                const selectedCoin = e.target.value;
                setCoin(selectedCoin);
                setSelectedCoinObj(
                  coins.find((c: any) => c.abbr === selectedCoin)
                );
              }}
              className="outline-none w-full text-[14px] bg-transparent text-gray-800 dark:text-gray-200"
            >
              <option value="" disabled>
                Select a coin
              </option>
              {coins.map((coin: any, index: any) => (
                <option key={index} value={coin.abbr}>
                  {coin.name}
                </option>
              ))}
            </select>
          </div>
          <div className="w-full mt-6">
            <h4 className="text-[13px] text-gray-700 dark:text-gray-300">
              Amount
            </h4>
            <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2  flex gap-1 justify-between items-center">
              <input
                type="number"
                placeholder="Amount"
                value={amount}
                onChange={handleChange}
                className="text-gray-700 dark:text-gray-300 w-full spin-button-none bg-transparent text-[13px] text-left outline-none"
              />
              <h4 className="text-[13px] font-bold text-secondary_button">
                {" "}
                {coin}
              </h4>
            </div>
          </div>
          <div className="w-full">
            <div className="  py-5">
              <h4 className="text-secondary_button text-[13px] font-bold">
                Cash Value
              </h4>
              <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100">
                {loading || isLoading
                  ? "----"
                  : amount && rate
                  ? formatAmount(
                      Number(amount) * coinRates[coin] * Number(rate)
                    )
                  : "0.00"}{" "}
                NGN
              </h4>
              <h4 className=" mt-2 text-[12px] font-bold text-[#BE6B0A]">
                Rate {formatAmount(rate)} NGN - 1USD
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CryptoRate;
